import {TextField} from "@mui/material";
import React from "react";

export function Form_Static(props) {
    const {item, localFormState, setLocalFormState} = props;
    const { inputSize = "normal", key } = item;
    let value = undefined;
    if (item.value !== undefined){
        if (typeof item.value === "string"){
            value = item.value;
        } else if (typeof item.value === "function"){
            value = item.value();
        }
    }
    else {
        value = localFormState[key];
    }

    return (<>
        <TextField
            label={item.label}
            helperText={item.helperText}
            variant="outlined"
            fullWidth={true}
            size={inputSize}
            InputLabelProps={{ shrink: true }}
            // variant="outlined"
            // inputProps={{type:(item.textType === undefined) ? 'text': item.textType }}
            // type={ (item.textType === undefined) ? 'text': item.textType }
            disabled={ true }
            value={value}
            onChange={
                (e) => {
                    // submit new state to the upper system
                    setLocalFormState({
                        ...localFormState,
                        [item.key]: e.target.value
                    });
                }
            }
        />
    </>);
}